module.exports = __webpack_public_path__ + "img/Sportlight-Logo-White.fd422a5a.svg";